import api from "./api.js";

export default class TicketPromotionApi {
  // ---------- 멤버십상품 ---------- //
  static async create(data) {
    return await api.post(`api/ticket-promotion`, data);
  }

  static async getList(params) {
    return await api.get(`api/ticket-promotion`, params);
  }

  static async delete(params) {
    return await api.del(`api/ticket-promotion`, params);
  }

  static async getById(id) {
    return await api.get(`api/ticket-promotion/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/ticket-promotion/${id}`, data);
  }

  static async updateActivation(id, data) {
    return await api.patch(`api/ticket-promotion/activation/${id}`, data);
  }
}
